import TableHead from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableHead';
import TableRow from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableRow';
import {
  FDLabelText,
  FDSwitchInput,
} from '@facet-wealth/design';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  useDivideColumns,
} from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionAssumptionsAndDetails/Layout/ScenarioSelectionDetailedSummaryPicker/ScenarioSelectionDetailedSummary/ScenarioSelectionDetailedSummarySections/useDividedColumns';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorderRadius } from 'Components/utils';
import { dataAttrs } from 'Helpers/Testing';
import { ScenarioSelectionDetailedSummaryStickyCell } from './ScenarioSelectionDetailedSummaryStickyCell';

const useStyles = buildUseStyles('ScenarioSelectionDetailedSummaryTableHeader', (theme) => ({
  row: {
    '& > th': {
      backgroundColor: theme.palette.common.white,
      paddingTop: '0',
      paddingBottom: '0',
      '&:first-child': getBorderRadius(theme.radius.md, { left: true }),
      '&:last-child': getBorderRadius(theme.radius.md, { right: true }),
      '&:only-child': getBorderRadius(theme.radius.md, { all: true }),
    },
  },
}));

export const ScenarioSelectionDetailedSummaryTableHeader = ({
  headerLabel, columns, showMonths, setShowMonths, dense,
}) => {
  const classes = useStyles();
  const allColumnContent = useMemo(() => ([
    headerLabel ? <FDLabelText value={headerLabel} /> : null,
    ...columns.map((c) => (
      <FDLabelText value={c.title} key={c.key} />
    )),
  ]), [headerLabel, columns]);
  const { stickyColumn, nonStickyColumns } = useDivideColumns({ showMonths, allColumnContent });
  return (
    <TableHead>
      <TableRow className={classes.row}>
        <ScenarioSelectionDetailedSummaryStickyCell
          showMonths={showMonths}
          stickyColumn={stickyColumn}
          dense={dense}
          background="white"
          // The label can't just be an FDSwitchInput since that uses 1em, so we have to wrap the switch input in the right font styling
          label={
            setShowMonths
              ? (
                <FDLabelText
                  value={<FDSwitchInput {...dataAttrs('scenario-selection-detail-summary-monthly-switch-input')} label="Monthly" value={showMonths} onChange={setShowMonths} />}
                />
              )
              : null}
        />
        {nonStickyColumns}
      </TableRow>
    </TableHead>
  );
};

ScenarioSelectionDetailedSummaryTableHeader.defaultProps = {
  setShowMonths: undefined,
};

ScenarioSelectionDetailedSummaryTableHeader.propTypes = {
  headerLabel: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  showMonths: PropTypes.bool.isRequired,
  setShowMonths: PropTypes.func,
  dense: PropTypes.bool.isRequired,
};
